<template>
    <div style="background: #ffffff">
        <p class="listTitle">{{title}}</p>
        <div class="new-introduce">
            <div class="introduce-img" >
            <img :src="imgUrl" style="width: 100%"/>
            </div>
            <div class="li" v-for="item in list" :key="item.id" @click="to_detail(item.id)">
                <div class="img">
                    <img :src="require('@/assets/image/product/'+item.image)">
                </div>
                <div class="item">{{item.name}}</div>
                <div></div>
            </div>
            <div style="clear: both"></div>
        </div>
    </div>
</template>

<script>
    import homeNews from '@/assets/image/home/home-new.png'
    import homeDerivative from '@/assets/image/home/home-derivative.png'
    import homeBasics from '@/assets/image/home/home-basics.png'
    export default {
        name: "newEnergy",
        props:['title','list','type'],
        data(){
            return{
                imgUrl:''
            }
        },
        mounted() {
            if(this.type==1){
            this.imgUrl=homeNews;
            }else if(this.type==2){
                this.imgUrl=homeDerivative;
            }else if(this.type==3){
                this.imgUrl=homeBasics;
            }
        },
        methods:{
            to_detail(id){
                this.$router.push('/productDetail?id='+id)
            }
        }
    }
</script>

<style scoped>
    .listTitle{
        padding-bottom: 20px;
    }
    .new-introduce{
        width: 1100px;
        text-align: left;
    }
    .introduce-img{
        width: 536px;
        height: 254px;
        border-radius: 10px;
        float: left;
        margin-right: 28px;
    }
    .new-introduce .li{
        width: 246px;
        height: 250px;
        border-radius: 10px;
        overflow: hidden;
        margin-right: 32px;
        float: left;
        margin-bottom: 22px;
        border: 2px solid #E6E8EB;
        cursor: pointer;
    }
    .new-introduce .li:nth-child(3){margin-right: 0}
    .new-introduce .li .img{
        width: 250px;
        height: 192px;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .new-introduce .li .img img{
        height: 100%;
    }
    .new-introduce .li .item{
        width: 254px;
        height: 60px;
        background: #0067AC;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 60px;
        padding-left: 22px;
        box-sizing: border-box;
    }
</style>